import React from 'react'
import { Tabs, Tab } from '@mui/material'
import { NavLink, useLocation } from 'react-router-dom'
import './menu.css'

const Menu = () => {
    const { pathname } = useLocation()
    const PATH = {
        UNITS: '/rooftops/units',
        WHEELS: '/rooftops/wheels',
        AIRFLOWS: '/rooftops/airFlows',
        FANS: '/rooftops/fans',
        OPTIONS: '/rooftops/options',
        QM: '/rooftops/qm',
    }
    const tabValue = [PATH.UNITS, PATH.WHEELS, PATH.AIRFLOWS, PATH.FANS, PATH.OPTIONS, PATH.QM].indexOf(pathname)

    return (
        <Tabs className='rooftop' value={tabValue === -1 ? 0 : tabValue}>
            <Tab id='rooftop-tab-units' className='tab' label='Units' component={NavLink} to={PATH.UNITS} />
            <Tab id='rooftop-tab-wheels' className='tab' label='Wheels' component={NavLink} to={PATH.WHEELS} />
            <Tab id='rooftop-tab-airflows' className='tab' label='AirFlows' component={NavLink} to={PATH.AIRFLOWS} />
            <Tab id='rooftop-tab-fans' className='tab' label='Fans' component={NavLink} to={PATH.FANS} />
            <Tab id='rooftop-tab-options' className='tab' label='OPTIONS' component={NavLink} to={PATH.OPTIONS} />
            <Tab id='rooftop-tab-qm' className='tab' label='QM' component={NavLink} to={PATH.QM} />
        </Tabs>
    )
}

export default Menu
